import React from 'react';
import {
  BooleanInput,
  Edit,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  Toolbar,
  SaveButton,
} from 'react-admin';

const PositionSpecialtiesEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleShowLayout>
      <TextField label="Position ID" source="position.id" />
      <TextField label="Position" source="position.display_name" />
      <TextField label="Specialty ID" source="specialty.id" />
      <TextField label="Specialty" source="specialty.label" />
    </SimpleShowLayout>
    <SimpleForm
      toolbar={
        <Toolbar>
          <SaveButton />
        </Toolbar>
      }
    >
      <BooleanInput source="high_risk" />
    </SimpleForm>
  </Edit>
);

export default PositionSpecialtiesEdit;
